import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import { classNames } from 'src/lib/utils/helpers'

interface NavOption {
  title: string
  key: string
  pathname: string
}

const FeatureStoreNavbar = () => {
  const router = useRouter()

  const listOptions: NavOption[] = [
    {
      title: 'All',
      key: 'all',
      pathname: '/app-store'
    },
    {
      title: 'Your Subscriptions',
      key: 'subscriptions',
      pathname: '/app-store/table'
    }
  ]

  return (
    <div className='flex w-full gap-4 h-7 align-center border-b-2 border-zinc-500/10 border-inset'>
      {listOptions.map((option, index) => {
        const active = router.pathname === option.pathname

        return (
          <p
            key={index}
            className={classNames(
              `text-sm cursor-pointer pb-1 border-b-2`,
              active
                ? 'text-text-sm-medium h-fit text-zinc-700 border-zinc-500'
                : 'text-text-sm-medium h-fit text-zinc-500 border-transparent'
            )}
            onClick={() => router.push(option.pathname)}
          >
            {option.title}
          </p>
        )
      })}
    </div>
  )
}

export default FeatureStoreNavbar
